/* eslint-disable jsx-a11y/control-has-associated-label */

/**
 * Legacy re-export — prefer CelebrationUserItemV2 from ui/v2/explore.
 */
export {
  CelebrationUserItemV2 as default,
  type CelebrationUserItemV2Props,
} from "components/ui/v2/explore/bundle/CelebrationUserItemV2";
